import DataPreview from './DataPreview'

export default DataPreview
